import styled from "styled-components";
import {BaseModal} from "../modal/modalStyle";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getLogByEntityAndAttribute} from "../log/logAction";
import LineChart from "../statistic/LineChart";
import ExitButton from "../buttons/ExitButton";

const StatisticsOKR = ({id, setOpen}) => {

    const dispatch = useDispatch()
    const {data} = useSelector(state => state.logs)
    const [labels, setLabels] = useState([])
    const [uniqueTargetValues, setUniqueTargetValue] = useState([])
    const [uniqueRealValues, setUniqueRealValue] = useState([])
    const [dataChart, setDataChart] = useState()

    useEffect(() => {
        return () => {
            setLabels([])
            setUniqueTargetValue([])
            setUniqueRealValue([])
            setDataChart({})
        }
    }, [])

    useEffect(() => {
        dispatch(getLogByEntityAndAttribute("keyResult", id))
    }, [dispatch, id])

    const padMonth = month => {
        if (month < 10) {
            return '0' + month;
        } else {
            return month;
        }
    }

    useEffect(() => {
        let d = new Date()
        let y = d.getFullYear()
        let m = d.getMonth()
        if (m === 11) {
            for (let i = 1; i < 13; i++) {
                setLabels(array => [...array, y + "-" + padMonth(i)])
            }
        } else {
            for (let i = m + 1; i < m + 13; i++) {
                if ((i % 12) > m) {
                    setLabels(array => [...array, (y - 1) + "-" + padMonth(i + 1)])
                } else {
                    setLabels(array => [...array, y + "-" + padMonth((i % 12) + 1)])
                }
            }
        }
    }, [])
    useEffect(() => {
        let realValues = data.filter(d => d.modifiedField === "advancement")
        let targetValues = data.filter(d => d.modifiedField === "target")

        let uniqueDateOfModificationForRealValues = []
        let uniqueDateOfModificationForTargetValues = []
        realValues.forEach((v) => {
            if (uniqueDateOfModificationForRealValues.slice(-1)[0]?.dateOfModification.slice(0, -3) !== (v.dateOfModification.slice(0, -3))) {
                uniqueDateOfModificationForRealValues.push(v)
            }
        })
        setUniqueRealValue(uniqueDateOfModificationForRealValues)


        targetValues.forEach((v) => {
            if (uniqueDateOfModificationForTargetValues.slice(-1)[0]?.dateOfModification.slice(0, -3) !== (v.dateOfModification.slice(0, -3))) {
                uniqueDateOfModificationForTargetValues.push(v)
            }
        })
        setUniqueTargetValue(uniqueDateOfModificationForTargetValues)
    }, [data])

    useEffect(() => {
        const getData = (type) => {
            let initialData = []
            let finalData = []
            if (type === "advancement") {
                initialData = uniqueRealValues
            }
            if (type === "target") {
                initialData = uniqueTargetValues
            }
            let labelIteration = 0
            labels.forEach((l) => {
                let dataIteration = 0
                initialData.forEach((v) => {
                    let isIterated = false
                    if (l === v.dateOfModification.slice(0, -3)) {
                        finalData.push(parseInt(v.newValue))
                    } else {
                        if (finalData.length === 0) {
                            finalData.push(0)
                        }
                        dataIteration++
                        isIterated = true
                        if (dataIteration === initialData.length && finalData[labelIteration] === undefined) {
                            let lastValue = finalData.slice(-1)[0]
                            finalData.push(lastValue)
                        }
                    }
                    if (!isIterated) {
                        dataIteration++
                    }
                })
                labelIteration++
            })
            return finalData
        }

        setDataChart({
            labels: labels,
            datasets: [
                {
                    label: "À atteindre",
                    data: getData("target"),
                    borderColor: 'rgba(73, 9, 170, 1)',
                    backgroundColor: 'rgba(73, 9, 170, 1)',
                },
                {
                    label: 'Atteint',
                    data: getData("advancement"),
                    borderColor: 'rgba(51, 148, 246,1)',
                    backgroundColor: 'rgba(51, 148, 246, 1)',
                },
            ]

        })
    }, [labels, uniqueRealValues, uniqueTargetValues])

    const close = () => {
        setOpen(false)
    }

    const options = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: "Avancement du résultat clé et sa cible",
            },
        },
    };

    return (
        <Modal>
            <FirstSection>
                <h1> Statistiques de mon résultat clé</h1>
                <ExitButton
                    closeUpdate={close}
                />
            </FirstSection>
            {dataChart && Object.keys(dataChart).length !== 0 && Object.getPrototypeOf(dataChart) === Object.prototype &&
            <Chart>
                <LineChart options={options} data={dataChart}/>
            </Chart>
            }
        </Modal>
    )
}


const Chart = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  justify-content: center;
  flex-grow: 1;
`
const Modal = styled(BaseModal)`
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  height: fit-content;
  @media (min-width: 768px ) {
    //width: 850px;
    width: 760px;
    height: fit-content;
  }
`
const FirstSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;;

  h1 {
    flex-grow: 1;
  }

`
export default StatisticsOKR